import React from 'react'
import css from './TrainerDashboard.module.scss'
import Badge from "@mui/material/Badge";
import InfoCard from "../../re_redesigned_componnents/card/InfoCard";

import {
    IconAssessmentScore,
    IconCompletion,
    IconLogout,
    IconOpenCourse,
    IconPleCredit,

  } from "re_redesigned_componnents/icon";
import StudentStatusCard from './StudentStatus/StudentStatusCard';
import AssessmentCard from './AssesmentCard/AssessmentCard';
import Calendar from '../../re_redesigned_componnents/Calendar/Calendar'
function TrainerDashboard() {
  return (
    <div className={css.wrap}>
        <div className={css.contentCard}>
    
        <div className={css.card_wrap}>
         
         <InfoCard
           color="#650076"
           icon={<IconOpenCourse />}
           title={"My Open Course"}
           value={"55"}
         />
         <InfoCard
           color="#990077"
           icon={<IconAssessmentScore />}
           title={"Avg Assmt Score"}
           value={"44"}
         />
         <InfoCard
           color="#CC0177"
           icon={<IconCompletion />}
           title={"Avg Completion Rate"}
           value={`${"44"}%`}
         />
         <InfoCard
           color="#4F1382"
           icon={<IconPleCredit />}
           title={"PLE Credits"}
           value={"55" || 0}
         />
        
       </div>
         
          <div className={css.smeCard}></div>
        </div>
        <div className={css.contentCard}>
        <div className={css.innerWrap}>
          <Calendar/>
        </div>
        <StudentStatusCard/>
        </div>
        <div className={css.contentCard}>
        <div className={css.innerWrap}>
          <AssessmentCard/>
          <AssessmentCard/>
          <AssessmentCard/>
          <AssessmentCard/>
       </div>
       <div className={css.innerWrap}>
          <AssessmentCard/>
          <AssessmentCard/>
          <AssessmentCard/>
          <AssessmentCard/>
          </div>
        </div>
    </div>
  )
}

export default TrainerDashboard